import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const DisplayModeContext = createContext();

export const useDisplayMode = () => {
  const context = useContext(DisplayModeContext);
  if (!context) {
    throw new Error('useDisplayMode must be used within a DisplayModeProvider');
  }
  return context;
};

export const DisplayModeProvider = ({ children }) => {
  const [displayMode, setDisplayMode] = useState('grid');

  return (
    <DisplayModeContext.Provider value={{ displayMode, setDisplayMode }}>
      {children}
    </DisplayModeContext.Provider>
  );
};

DisplayModeProvider.propTypes = {
  children: PropTypes.node.isRequired,
}; 